import React from 'react'

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-grey-300 '>
        <div className='flex flex-col justify-center items-centerw-full h-full'>
            <div className='max-w -[1000px] w-full grid grid-cols-2 gap-8'>
                <div className='sm:text-right pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>
                        About
                    </p>
                </div>
                    <div></div>
            </div>
                
            <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4 text-gray-300'>
                <div className= 'sm:text-right text-4xl font-bold'>
                    <p>Hi. I'm Razak, nice to meet you. Please take a look around.</p>
                </div>
                
                <div>

                <p>Having started off creating wireframes & UI/UX mockups, I’ve long since moved to development as my area of focus. I am passionate about 
                    technology and its ability to create unique digital footprints. What would you build if you 
                    had a developer available at your 
                    figertips?</p>
                </div>
            </div>
        </div>
    </div>
  );
};

export default About



